import React, { RefObject } from 'react';
import { useScrollReveal } from '../../../hooks';
import { SectionHeader } from '../../../sections/ThesisSection/layouts';
import { Result, STEPS } from '../content';
import { Lineage } from '../figures/Lineage';
import { rich } from '../rich';
import { Band, reveal } from './Band';

// A measured gain: the model, the data it was measured on, and its accuracy before and after.
function StepResult({ result }: { result: Result }) {
  return (
    <p className="oh-result">
      <em className="oh-model-name">{result.model}</em>
      {result.on && <span className="oh-result-on">{result.on}</span>}
      <span className="oh-result-score">
        {result.from} <span aria-hidden="true">→</span> <b>{result.to}</b>
      </span>
    </p>
  );
}

export function YoursSection() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });
  return (
    <Band id="make-it-yours" tone="secondary">
      <div ref={ref as RefObject<HTMLDivElement>}>
        <SectionHeader
          label="Make it yours"
          title="Start from the strongest base. Then make it yours."
          description="Tune on your own examples in the console, with no training infrastructure to run."
          isVisible={isVisible}
          labelColor="ink"
        />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <ol className="grid gap-10">
            {STEPS.map((step, i) => (
              <li key={step.title} className={reveal(isVisible)} style={{ animationDelay: `${0.2 + i * 0.08}s` }}>
                <div className="text-label font-mono text-foreground-secondary dark:text-white/70">0{i + 1}</div>
                <h3 className="mt-2 font-display text-heading-lg text-foreground">{step.title}</h3>
                <p className="mt-2 font-body text-body text-foreground-tertiary leading-relaxed max-w-md">{rich(step.text)}</p>
                {step.result && <StepResult result={step.result} />}
              </li>
            ))}
          </ol>
          <div className={reveal(isVisible)} style={{ animationDelay: '0.3s' }}>
            <Lineage />
          </div>
        </div>
      </div>
    </Band>
  );
}

export default YoursSection;
